import CoinDefinition from './coin-definition'
import Currency from './currency'
import Denomination from './denomination'

const coinDefinitions: CoinDefinition[] = []

const getBaseColor = (denomination: Denomination): number => {
  switch (denomination) {
    case 100:
    case 200:
    case 2000:
    case 3000:
    case 4000:
    case 10000:
    case 20000:
    case 30000:
    case 100000:
    case 300000:
      return 0xc9a08e
    case 300:
    case 400:
    case 5000:
    case 6000:
    case 7000:
    case 40000:
    case 50000:
    case 60000:
    case 200000:
    case 400000:
    case 600000:
      return 0xfcfaf5
    case 500:
    case 600:
    case 700:
    case 800:
    case 900:
    case 1000:
    case 8000:
    case 9000:
    case 70000:
    case 80000:
    case 90000:
    case 500000:
    case 700000:
    case 800000:
    case 900000:
      return 0xffcb67
  }

  return 0xffffff
}

const level1Denominations = [
  Denomination.One,
  Denomination.Two,
  Denomination.Three,
  Denomination.Four,
  Denomination.Five,
  Denomination.Six,
  Denomination.Seven,
  Denomination.Eight,
  Denomination.Nine,
  Denomination.Ten
]
level1Denominations.forEach((denomination: Denomination, index) => {
  coinDefinitions.push({
    denomination,
    currency: Currency.ALL,
    radius: 86,
    extraLevelScale: 1 + (index > 2 ? 0.1 : 0) + (index > 3 ? 0.1 : 0),
    level: 1,
    weight: 0.003,
    modelName: 'Level_1_Coin.glb',
    normalMap: 'Level_1_' + Number(denomination) / 100 + 'KR_normal.png',
    diffuseMap: 'Level_1_' + Number(denomination) / 100 + 'KR_BaseColor.png',
    gemColor: 0x000000,
    baseColor: getBaseColor(denomination),
    loadOnStart: true
  })
})

const level2Denominations = [
  Denomination.Twenty,
  Denomination.Thirty,
  Denomination.Forty,
  Denomination.Fifty,
  Denomination.Sixty,
  Denomination.Seventy,
  Denomination.Eighty,
  Denomination.Ninety
]
level2Denominations.forEach((denomination: Denomination, index) => {
  coinDefinitions.push({
    denomination,
    currency: Currency.ALL,
    radius: 222,
    extraLevelScale: 1 + (index > 2 ? 0.1 : 0) + (index > 5 ? 0.1 : 0),
    level: 2,
    weight: 0.002,
    modelName: 'Level_2_Coin.glb',
    normalMap: 'Level_2_' + Number(denomination) / 100 + 'KR_normal.png',
    diffuseMap: 'Level_2_' + Number(denomination) / 100 + 'KR_BaseColor.png',
    gemColor: 0x000000,
    baseColor: getBaseColor(denomination),
    loadOnStart: false
  })
})

const level3Denominations = [
  Denomination.OneHundred,
  Denomination.TwoHundred,
  Denomination.ThreeHundred,
  Denomination.FourHundred,
  Denomination.FiveHundred,
  Denomination.SixHundred,
  Denomination.SevenHundred,
  Denomination.EightHundred,
  Denomination.NineHundred
]

const gemColors = [
  0x4b7e1c, 0x4f9c24, 0x55c430, 0x054a7e, 0x0860a6, 0x0d7cd3, 0x902398, 0xb42ebf, 0xd438e1, 0x339933, 0x333399
]
level3Denominations.forEach((denomination: Denomination, index: number) => {
  coinDefinitions.push({
    denomination,
    currency: Currency.ALL,
    radius: 220,
    extraLevelScale: 1 + (index > 2 ? 0.1 : 0) + (index > 5 ? 0.1 : 0),
    weight: 0.001,
    level: 3,
    modelName: 'Level_3_Coin.glb',
    normalMap: 'Level_3_' + Number(denomination) / 100 + 'KR_normal.png',
    diffuseMap: 'Level_3_' + Number(denomination) / 100 + 'KR_BaseColor.png',
    gemColor: gemColors[index],
    baseColor: getBaseColor(denomination),
    loadOnStart: false
  })
})

const level4Denominations = [
  Denomination.OneThousand,
  Denomination.TwoThousand,
  Denomination.ThreeThousand,
  Denomination.FourThousand,
  Denomination.FiveThousand,
  Denomination.SixThousand,
  Denomination.SevenThousand,
  Denomination.EightThousand,
  Denomination.NineThousand
]
level4Denominations.forEach((denomination: Denomination, index) => {
  coinDefinitions.push({
    denomination,
    currency: Currency.ALL,
    radius: 300,
    extraLevelScale: 1,
    level: 4,
    weight: 0.001,
    modelName: 'Level_4_Coin.glb',
    normalMap: 'Level_4_' + Number(denomination) / 100 + 'KR_normal.png',
    diffuseMap: 'Level_4_' + Number(denomination) / 100 + 'KR_BaseColor.png',
    gemColor: 0x000000,
    baseColor: getBaseColor(denomination),
    loadOnStart: false
  })
})

export default coinDefinitions
